export default __webpack_public_path__ + "static/media/notes-light.e9652668.svg";